var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-partners"},[_c('div',{staticClass:"g-box"},[_vm._m(0),_c('div',{staticClass:"inner-img"},[_c('img',{staticClass:"img",attrs:{"src":_vm.contentInfo.image,"alt":""},on:{"click":_vm.toDetail}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners-title"},[_c('div',{staticClass:"tt"},[_vm._v("Partners")]),_c('div',{staticClass:"tit"},[_vm._v("合作院校")])])
}]

export { render, staticRenderFns }